export default __webpack_public_path__ + "static/first_impression-a25015845688eaf76de3a7e3b1477dce.png";